'use client'

import { type AtRisLaw } from '@shared/lib/ris.types'
import { createContext, useContext, type ReactNode } from 'react'

export const NormContext = createContext<AtRisLaw | null>(null)

/**
 * Makes all norm metadata (`normId`, `title`, etc.) accessible though React context
 * TODO: after full migration to PG, use LawPG instead of AtRisLaw
 */
export default function NormProvider({
  children,
  norm,
}: {
  children: ReactNode
  norm: AtRisLaw
}) {
  return <NormContext.Provider value={norm}>{children}</NormContext.Provider>
}

export function useNormContext() {
  return useContext(NormContext) as AtRisLaw
}
